// 2026-05-26 - FormuLearning - 프로젝트 API 호출
// 2026-09-21 수정 - 이슈 #77(G6): 목록에 폴더 동봉 · 프로젝트 이동 · 폴더 생성·이름변경·이동·삭제
// 파일 위치: frontend/src/api/projects.ts

import client from './client'
import type { ApiResponse } from '../types/api'
import type { ProjectDetail, ProjectCreate, ProjectGating, ProjectFolder, ProjectListing } from '../types/project'

// 이슈 #77: 폴더를 같은 응답에 싣는다 — 트리를 한 번의 호출로 조립한다.
export async function listProjects(): Promise<ProjectListing> {
  const { data } = await client.get<ApiResponse<ProjectListing>>('/projects/')
  return { items: data.data!.items, folders: data.data!.folders ?? [] }
}

export async function createProject(body: ProjectCreate): Promise<ProjectDetail> {
  const { data } = await client.post<ApiResponse<ProjectDetail>>('/projects/', body)
  return data.data!
}

export async function getProject(id: string): Promise<ProjectDetail> {
  const { data } = await client.get<ApiResponse<ProjectDetail>>(`/projects/${id}`)
  return data.data!
}

export async function deleteProject(id: string): Promise<void> {
  await client.delete(`/projects/${id}`)
}

// 2026-07-09 - 스텝 게이팅 조회 (이슈 #33): 완료 판정·RLD 선택·runs 수.
export async function getGating(id: string): Promise<ProjectGating> {
  const { data } = await client.get<ApiResponse<ProjectGating>>(`/projects/${id}/gating`)
  return data.data!
}

// 2026-07-09 - 진행도·기본정보 갱신 (이슈 #33). current_step은 서버에서 clamp·단조증가.
export async function updateProject(
  id: string,
  body: Partial<Pick<ProjectDetail, 'name' | 'smiles' | 'memo' | 'current_step'>>,
): Promise<ProjectDetail> {
  const { data } = await client.put<ApiResponse<ProjectDetail>>(`/projects/${id}`, body)
  return data.data!
}

// 2026-06-19 - 프로젝트 소프트 숨김/해제 (이슈 #7)
export async function hideProject(id: string): Promise<ProjectDetail> {
  const { data } = await client.put<ApiResponse<ProjectDetail>>(`/projects/${id}/hide`)
  return data.data!
}

export async function unhideProject(id: string): Promise<ProjectDetail> {
  const { data } = await client.put<ApiResponse<ProjectDetail>>(`/projects/${id}/unhide`)
  return data.data!
}

// 2026-07-18 - 이슈 #40: 전 스텝 AI Summary(영/국) 일괄 조회. 프로젝트 로드 시 summaryStore 중앙 populate용.
export async function getProjectSummaries(id: string): Promise<Record<string, { en: string | null; ko: string | null }>> {
  const { data } = await client.get<ApiResponse<Record<string, { en: string | null; ko: string | null }>>>(`/projects/${id}/ai-summaries`)
  return data.data!
}

// 2026-09-21 - 이슈 #77: 폴더로 이동 · 루트로 꺼내기(folderId null). 내부데이터 시각은 바뀌지 않는다.
export async function moveProject(id: string, folderId: string | null): Promise<ProjectDetail> {
  const { data } = await client.put<ApiResponse<ProjectDetail>>(`/projects/${id}/move`, { folder_id: folderId })
  return data.data!
}

// 2026-09-21 - 이슈 #77: 사용자 폴더 (BR-PRJ-05~07). 이름 중복·순환 이동·승계 충돌은 409 + 안내 문장.
export async function createFolder(name: string, parentId: string | null): Promise<ProjectFolder> {
  const { data } = await client.post<ApiResponse<ProjectFolder>>('/project-folders/', { name, parent_id: parentId })
  return data.data!
}

export async function renameFolder(id: string, name: string): Promise<ProjectFolder> {
  const { data } = await client.put<ApiResponse<ProjectFolder>>(`/project-folders/${id}`, { name })
  return data.data!
}

export async function moveFolder(id: string, parentId: string | null): Promise<ProjectFolder> {
  const { data } = await client.put<ApiResponse<ProjectFolder>>(`/project-folders/${id}/move`, { parent_id: parentId })
  return data.data!
}

export async function deleteFolder(id: string): Promise<{ moved_folders: number; moved_projects: number }> {
  const { data } = await client.delete<ApiResponse<{ moved_folders: number; moved_projects: number }>>(`/project-folders/${id}`)
  return data.data!
}
